
import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";

export default function DropDownDurationProfessional(props) {
    const { selectedTimeRangeForUIShow, selectedStartDate, preferredDates } = useSelector((state) => state.createOrderSlice)
    const { options, onChange, disableCondition, error, index } = props;

    function timeRangeSelectionFormat(timeRange) {
        // Format start time
        const startHour = timeRange?.startTime?.hours < 10 ? `0${timeRange?.startTime?.hours}` : timeRange?.startTime.hours;
        const startMinutes = timeRange?.startTime?.minutes === 0 ? '00' : '30';
        const formattedStartTime = `${startHour}:${startMinutes}`;
        // Create option value
        const optionValue = `${formattedStartTime}`;
        return optionValue;
    }


    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                
                <Select
                    labelId="demo-simple-select-label"
                    disabled={disableCondition}
                    value={new Date(preferredDates[index]).getHours() ? new Date(preferredDates[index]).getHours() : "Select Time Range"}
                >
                    <MenuItem style={{ display: "none" }} onClick={() => { }} value={"Select Time Range"}>Select Time Range</MenuItem>
                    {options?.map((timeRange, index) => {
                        return (
                            <MenuItem onClick={() => onChange(timeRange)} key={index} value={timeRange?.startTime?.hours}>{timeRangeSelectionFormat(timeRange)}</MenuItem>
                        );
                    })}
                </Select>

                {error ? !selectedStartDate && <p className='form-error-message'>This field is required</p> : null}
            </FormControl>
        </Box>
    );
}


